import React, { useState } from "react";
import "./synchroniseUsers.css";
import strings from "../../../utils/property-file/Employeedetails.json";
import Ripple from "../../button/ripple";

const UserSyncTables = ({ synchroniseUsers ,onConfirm}) => {
  const adminData = synchroniseUsers.find(u => u.userType === "admin")?.userList || [];
  const staffData = synchroniseUsers.find(u => u.userType === "staff")?.userList || [];
  const [selectedUsers, setSelectedUsers] = useState({ admin: [], staff: [] });
  const [allSelectedUsers, setAllSelectedUsers] = useState([]);

  const isDisabled = (email, type) => {
    const opposite = type === "admin" ? "staff" : "admin";
    return selectedUsers[opposite].some(user => user.emailId === email);
  };


  const handleCheckboxChange = (user, type) => {
    const opposite = type === "admin" ? "staff" : "admin";
    const email = user.emailId;
    setSelectedUsers(prev => {
      const isAlreadySelected = prev[type].some(u => u.emailId === email);
      const newTypeList = isAlreadySelected
        ? prev[type].filter(u => u.emailId !== email)
        : [...prev[type], user];
      const newOppositeList = prev[opposite].filter(u => u.emailId !== email); 
       const newSelected = {
      ...prev,
      [type]: newTypeList,
      [opposite]: newOppositeList,
    };
      updateAllSelectedUsers(newSelected);
      return newSelected
    });
  };

const updateAllSelectedUsers = (newSelectedUsers) => {
  console.log("updateAllSelectedUsers",newSelectedUsers);
  const merged = [
    ...newSelectedUsers.admin.map(user => ({ userId: user.userId, type: "admin" ,emailId:user.emailId})),
    ...newSelectedUsers.staff.map(user => ({ userId: user.userId, type: "staff",emailId:user.emailId })),
  ];
  setAllSelectedUsers(merged);
};

  const handleSelectAll = (type, data) => {
    const opposite = type === "admin" ? "staff" : "admin";
    const filtered = data.filter(
      user => !selectedUsers[opposite].some(u => u.emailId === user.emailId)
    );
    setSelectedUsers(prev => {
      const newOppositeList = prev[opposite].filter(
        u => !filtered.some(f => f.emailId === u.emailId)
      );
      const newSelected = {
      ...prev,
      [type]: filtered,
      [opposite]: newOppositeList,
    };

    updateAllSelectedUsers(newSelected);
    return newSelected;
      
    });
  };


  const handleUnselectAll = (type) => {
   setSelectedUsers(prev => {
    const newSelected = {
      ...prev,
      [type]: [],
    };
    updateAllSelectedUsers(newSelected);
    return newSelected;
  });
  };


  const renderTable = (type, data) => {
    const opposite = type === "admin" ? "staff" : "admin";
    const allSelectable = data.filter(
      user => !selectedUsers[opposite].some(u => u.emailId === user.emailId)
    );
    const allSelected = allSelectable.length > 0 && allSelectable.every(user =>
      selectedUsers[type].some(u => u.emailId === user.emailId)
    );
    const handleSynchroniseUserData = () => {
 const allUsers = synchroniseUsers.flatMap(group => {
  const type = group.userType;

  return group.userList.map(user => {
    const existsInSelected = allSelectedUsers.some(
      item => String(item.userId) === String(user.userId) && item.type === type
    );
    return {
      bluewingsUserId: user.userId,
      type,
      isActive: existsInSelected ? user.isActive : 0
    };
  });
})
      onConfirm(allUsers);
    };
    return (
      <div>
        <button
          type="button"
          className="btn add-emp-btn btn-secondary synchronise-btn"
          onClick={handleSynchroniseUserData}
        >
          {strings.synchronise}
          <Ripple duration={1000} />
        </button>
        <div className="main-container-synchronise-user">
            <div className={type === "admin" ? "table-name" : "table-name-staff" }>{type === "admin" ? "Admin Data" : "Staff Data"}</div>
   
            <div class="syncronize-table">
              <table>
                <thead>
                  <tr>
                    <th scope="col" className="left-spacing">
                      <input
                        type="checkbox"
                        className="input-position"
                        onChange={() =>
                          allSelected
                            ? handleUnselectAll(type)
                            : handleSelectAll(type, data)
                        }
                        checked={allSelected}
                      />
                      <span>Select</span>
                    </th>
                    <th >Name</th>
                    <th >Email</th>
                    <th >Mobile number</th>
                    <th >Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((user, index) => {
                    const selected = selectedUsers[type].some(u => u.emailId === user.emailId);
                    const disabled = isDisabled(user.emailId, type);


                    return (
                      <tr key={`${type}-${index}`}>
                        <td className="left-spacing">
                          <input
                            type="checkbox"
                            checked={selected}
                            disabled={disabled}
                            onChange={() => handleCheckboxChange(user, type)}
                          />
                        </td>
                        <td >{user.name}</td>
                        <td >{user.emailId}</td>
                        <td style={{ paddingLeft: '9px' }}>{user.mobileNumber}</td>
                          <td >
                            <span className={user.isActive ? "active-status" : "inactive-status"}>
                              {user.isActive ? "Active" : "Inactive"}
                            </span>
                          </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        
      </div>
    );
  };


  return (
    <>
      {renderTable("admin", adminData)}
      {renderTable("staff", staffData)}
    </>
  );
};


export default UserSyncTables;




